// extracted by mini-css-extract-plugin
export default {"root":"UserNav_root__blWkg","tab":"UserNav_tab__-WMZ9"};